export const SET_LOADING = '@VM_Details/SET_LOADING';
export const SAVE_DATA = '@VM_Details/SAVE_DATA';



// WEBPACK FOOTER //
// ./src/Modules/VMDetails/constants.js